import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c045e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-footer shadow-lg p-py-2" }
const _hoisted_2 = { class: "p-px-3 p-mb-3" }
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 0,
  class: "p-ml-2 p-mt-4 w-50"
}
const _hoisted_6 = {
  key: 1,
  class: "p-ml-2 p-mt-4 w-50"
}
const _hoisted_7 = { class: "p-mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "note" }, "รายละเอียดเพิ่มเติม", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cutom-margin-bottom" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckoutPolicy = _resolveComponent("CheckoutPolicy")!
  const _component_TransactionHeader = _resolveComponent("TransactionHeader")!
  const _component_CheckoutCartDetail = _resolveComponent("CheckoutCartDetail")!
  const _component_CheckoutFooter = _resolveComponent("CheckoutFooter")!
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isShowCartPolicy)
      ? (_openBlock(), _createBlock(_component_CheckoutPolicy, {
          key: 0,
          onOnSaveOrder: _ctx.onSaveOrder
        }, null, 8, ["onOnSaveOrder"]))
      : (!_ctx.isShowCartPolicy)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", null, [
              _createVNode(_component_TransactionHeader, {
                transactionInvoice: '',
                statusId: '1',
                statusName: 'สั่งซื้อ',
                tittle: 'ตะกร้าสินค้า',
                isDisplayInvoice: false
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_CheckoutCartDetail, {
                ref: "checkoutCartDetailPanel",
                onOnSaveCart: _ctx.onSaveCart
              }, null, 8, ["onOnSaveCart"])
            ]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_CheckoutFooter, { onOnSaveOrder: _ctx.onSaveOrder }, null, 8, ["onOnSaveOrder"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_InputTextCustom, {
                    "model-value": _ctx.promoCode,
                    textFloat: "คูปองโค้ด",
                    placeholder: "กรุณาใส่คูปองโค้ด",
                    type: "text",
                    name: "promoCode",
                    isDisplay: _ctx.isDisableCoupon,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.promoCode = $event)),
                    class: "f-regular w-100"
                  }, null, 8, ["model-value", "isDisplay"])
                ]),
                (!_ctx.isDisableCoupon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_Button, {
                        label: "ใช้คูปอง",
                        disabled: _ctx.promoCode.length == 0,
                        class: "bg-black custom-button w-100",
                        onClick: _ctx.onUseCoupon
                      }, null, 8, ["disabled", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDisableCoupon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_Button, {
                        label: "ลบคูปอง",
                        class: "bg-black custom-button w-100",
                        onClick: _ctx.onRemoveCoupon
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.note,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.note) = $event)),
                  rows: "3",
                  class: "custom-textarea"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_9
          ], 64))
        : _createCommentVNode("", true)
  ]))
}